import { updateTenantId } from '../careand-redux/api/ApiThunks';
import { Device } from './Native/Device';
import config from 'config';

//@ts-ignore
window.careand = {
  debug: {},
};

/*
 * Adds window.careand.debug.*
 * functions to help with development and debugging
 */
if (config.ENVIRONMENT === 'staging') {
  function emitNativeEvent(data: any) {
    const event = new CustomEvent('nativeEvent', { detail: data });
    window.dispatchEvent(event);
  }
  function emitPush(content: any) {
    const message = {
      id: `${Math.random()}`,
      type: 'pushNotificationReceived',
      content,
    };
    emitNativeEvent(message);
  }
  function simulateAndroid() {
    //@ts-ignore
    Device.isAndroid = function () {
      return true;
    };
    //@ts-ignore
    Device.isIOS = function () {
      return false;
    };
    //@ts-ignore
    Device.getMessageHandler = function () {
      return () => {};
    };
  }
  function simulateIOS() {
    //@ts-ignore
    Device.isAndroid = function () {
      return false;
    };
    //@ts-ignore
    Device.isIOS = function () {
      return true;
    };
    //@ts-ignore
    Device.getMessageHandler = function () {
      return () => {};
    };
  }
  //@ts-ignore
  Object.assign(window.careand.debug, {
    emitNativeEvent,
    simulateAndroid,
    simulateIOS,
    emitPush,
  });
}

(window as any).careand.debug.forceTenantId = updateTenantId;

export default (window as any).careand.debug;
